import { render } from "./CarouselCard.vue?vue&type=template&id=12fc04ac&scoped=true"
import script from "./CarouselCard.vue?vue&type=script&lang=js"
export * from "./CarouselCard.vue?vue&type=script&lang=js"

import "./CarouselCard.vue?vue&type=style&index=0&id=12fc04ac&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12fc04ac"]])

export default __exports__